var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentinelBeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.1418 20.2335L24.5628 19.416H25.5768L27.2658 17.784L43.2243 14.6475L42.0198 13.503L41.4108 11.778L40.0203 10.6575L39.0918 10.4625L36.3333 7.36499L36.5013 6.12749L36.0363 4.59299L34.6428 2.80499L36.3333 1.22699L38.4783 2.34449L39.6543 2.63549L43.5408 5.05649L44.4978 6.18299L52.3308 12.321H54.0708L54.6333 13.1805L55.6473 14.9685L58.7028 17.277L60.3783 16.32H62.2324L59.1393 12.885L60.0003 10.506L62.2324 9.92849H63.8478L78.4819 15.936L82.2363 19.416L81.6078 15.249L86.3374 14.3205L91.5754 18.966L96.8148 32.967L96.4519 33.966L98.1214 35.694L102.134 46.7565L96.8958 52.077L93.8254 51.534L95.4604 53.3445L89.8848 58.7685H87.9424L69.8658 39.576L55.6758 37.83L54.0708 38.5065L32.2353 38.457L30.1518 35.694L28.3413 35.4555L27.2658 32.745L27.8868 29.7975L26.6193 26.3985L22.1418 20.2335Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 47.7494L97.9389 42.5039L94.5039 43.7429",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9817 34.5075L91.1317 40.101L88.6192 42.504L87.6892 38.5065L92.8417 33.621L96.9817 34.5075Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1318 40.101L99.6623 49.266",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1572 44.3069L87.5212 50.1344L91.3477 48.7934",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3048 16.4145L71.2363 23.757L75.2698 24.7095L80.0458 19.8105L79.3048 16.4145Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0449 19.8105L92.8414 33.621",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2693 24.7094L87.6893 38.5064",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2168 24.0345L84.1843 31.2135L84.5653 32.967L87.6898 36.93L91.5763 33.4095L87.6898 29.4525L83.9308 28.173L79.2853 23.415L77.2168 24.0345Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0029 20.8799L82.1574 24.4139L83.8674 23.9354",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9379 38.0625L67.7559 35.9445L73.7529 31.383L70.2054 26.2305",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7754 35.1674L73.4134 36.4934L81.4354 45.2849",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4141 36.4934L78.4826 32.1464",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5264 37.7129L79.7884 33.1979",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2861 36.4934L81.6081 42.0674L83.3391 40.5899L77.7696 34.9304",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5889 26.2304L69.2749 24.0344L72.2314 31.6079L62.5849 33.4094",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0135 10.4069L61.208 11.7014L67.163 17.2769L69.866 15.2489L77.216 18.3149",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1631 17.277L69.2121 18.966L71.0076 17.5305L73.7526 18.543L75.2691 17.5305",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9934 2.87543L40.0914 6.04193L39.5424 7.85843L40.8099 9.20993L45.3684 6.85193L46.9194 8.04443L43.6404 9.20993L43.7664 10.6034L53.8179 17.8679L54.7479 19.8104L59.3934 22.8929",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5523 10.4069L47.9053 11.0684L48.7288 12.8849L55.3393 17.2769L56.7583 21.1454",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8684 24.0344L53.7894 21.6119L54.6339 23.8064",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3379 25.0724L52.7769 22.8929L53.1144 24.0344",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7031 17.277L60.0006 20.2605L62.0106 19.416L60.6876 16.4145",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7266 19.9559L61.8711 22.4579L62.3766 22.2884L65.2491 21.3314L64.5726 19.6139L63.5886 19.1069L62.0106 19.4159",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3767 22.2885L63.6727 25.47",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3994 21.9479L64.9669 25.0724",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5173 21.6119L66.9098 24.4139",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0831 48.3L85.1556 41.9415L95.4606 53.3445L89.8851 58.7685H87.9426L69.8661 39.576L55.6761 37.83L54.4086 38.457H32.2356L29.5746 34.9305L27.4626 28.5105C27.4626 28.5105 26.7876 26.736 26.6181 26.3985C26.4486 26.061 22.1406 20.232 22.1406 20.232L24.5616 19.416H25.5756L27.2646 17.7825L43.5951 14.5725",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3926 10.6874L96.8956 52.0769L102.132 46.7549V45.8264C102.132 45.8264 98.6686 36.0284 97.8241 35.2679L96.9796 34.5074L79.0726 16.1774L63.8476 9.92694H61.9261L59.3926 10.6874Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7874 19.98L81.6084 15.249L86.3379 14.3205L91.5759 18.966L96.9819 33.4095",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M89.593 26.9445L87.5215 19.8105L91.576 18.966",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5214 19.8105L81.6084 15.249",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8962 52.077L93.3352 50.9925",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3926 10.6875L59.1391 12.885L62.2321 16.32H60.3781L58.8016 17.22L55.6471 14.9685L54.6901 12.4335L52.7761 12.546L44.4976 6.18299L43.5406 5.05649L39.6541 2.63549H39.0361L36.3331 1.22699L34.6426 2.80499L35.9386 4.26899L36.5011 6.12749L36.3331 7.36499L38.0221 9.22349L39.0916 10.4625L39.8236 10.5195L41.3446 11.589L42.0196 13.503L46.0186 16.263L47.2576 16.1505L57.1681 23.415",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0476 15.249L42.9211 17.8965L32.0521 22.119L27.2656 17.784",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9796 21.759L36.6711 26.9445L59.3931 23.133L64.2637 31.002L61.5036 34.959H55.4796L49.8471 32.256L48.4371 30.5655H35.0376L33.5166 27.357L30.0816 25.047L25.5771 19.416",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2637 31.002L49.8472 32.256L29.5762 34.9305",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1516 35.694H28.5616L27.8851 34.959L27.2656 32.967L27.8866 29.7975",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5506 38.4569L47.5391 35.6939L48.4376 34.2824H50.6936L55.9856 36.6719L69.2756 38.4569L69.8666 39.5759",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentinelBeam);
export default __webpack_public_path__ + "static/media/Sentinel Beam.de46960cada73808272c78b3d7862473.svg";
export { ForwardRef as ReactComponent };